/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S8_HeadingInputs */

const tr_mesafeli_s8_heading = /** @type {(inputs: Mesafeli_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Tarafların Hak ve Yükümlülükleri`)
};

const en_mesafeli_s8_heading = /** @type {(inputs: Mesafeli_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Rights and Obligations of the Parties`)
};

const de_mesafeli_s8_heading = /** @type {(inputs: Mesafeli_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Rechte und Pflichten der Parteien`)
};

const ru_mesafeli_s8_heading = /** @type {(inputs: Mesafeli_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Права и обязанности сторон`)
};

/**
* | output |
* | --- |
* | "8. Rights and Obligations of the Parties" |
*
* @param {Mesafeli_S8_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s8_heading = /** @type {((inputs?: Mesafeli_S8_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S8_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s8_heading(inputs)
	if (locale === "de") return de_mesafeli_s8_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s8_heading(inputs)
	return tr_mesafeli_s8_heading(inputs)
});